import { render, staticRenderFns } from "./VdrTools.vue?vue&type=template&id=566dade7&scoped=true"
import script from "./VdrTools.vue?vue&type=script&lang=js"
export * from "./VdrTools.vue?vue&type=script&lang=js"
import style0 from "./VdrTools.vue?vue&type=style&index=0&id=566dade7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566dade7",
  null
  
)

export default component.exports